var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 990",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407.413 384.034l-155.945-99.237a14.25 14.25 0 0 0-14.446-.468 14.208 14.208 0 0 0-7.344 12.432v198.476c0 5.175 2.822 9.938 7.358 12.433a14.18 14.18 0 0 0 6.819 1.744c2.651 0 5.302-.752 7.613-2.212l155.945-99.236A14.203 14.203 0 0 0 413.976 396a14.202 14.202 0 0 0-6.563-11.966zm-149.381 85.387V322.578L373.389 396l-115.357 73.421z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M601.448 153.311H10.552C4.727 153.311 0 158.027 0 163.862v464.275c0 5.835 4.727 10.552 10.552 10.552h590.897c5.824 0 10.552-4.717 10.552-10.552V163.862c-.001-5.835-4.729-10.551-10.553-10.551zM105.517 385.448H21.104v-94.965h84.414v94.965zm-84.413 21.104h84.414v94.966H21.104v-94.966zm105.517 105.517V174.414h358.758v443.172H126.621V512.069zm464.275-126.621h-84.414v-94.965h84.414v94.965zm-84.414 21.104h84.414v94.966h-84.414v-94.966zm84.414-232.138v94.965h-84.414v-94.965h84.414zm-569.792 0h84.414v94.965H21.104v-94.965zm0 443.172v-94.965h84.414v94.965H21.104zm569.792 0h-84.414v-94.965h84.414v94.965z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.fe34e56a2c7e2c269afee5734009ac73.svg";
export { ForwardRef as ReactComponent };